import React, { useState, useEffect } from "react";
import WeatherForecastDay from "./WeatherForecastDay";
import axios from "axios";

import "./DailyWeatherForecast.css";

export default function DailyForecast(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecastData, setForecastData] = useState(null);

  useEffect(() => {
    let apiKey = "4f25d827925b137070a1t4ad0aa3odaf";
    let lat = props.coordinates.latitude;
    let lon = props.coordinates.longitude;
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?lat=${lat}&lon=${lon}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then((response) => {
      setForecastData(response.data.daily);
      setLoaded(true);
    });
  }, [props.coordinates.latitude, props.coordinates.longitude]);

  if (loaded) {
    return (
      <div className="weeklyForecast">
        <h3>Weekly Forecast</h3>
        <div className="weeklyForecast-container">
          <div className="row">
            <div className="col">
              <WeatherForecastDay data={forecastData[1]} />
            </div>
            <div className="col">
              <WeatherForecastDay data={forecastData[2]} />
            </div>
            <div className="col">
              <WeatherForecastDay data={forecastData[3]} />
            </div>
            <div className="col">
              <WeatherForecastDay data={forecastData[4]} />
            </div>
            <div className="col">
              <WeatherForecastDay data={forecastData[5]} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
}
